import { render } from "./Tables.vue?vue&type=template&id=255c5802"
import script from "./Tables.vue?vue&type=script&lang=js"
export * from "./Tables.vue?vue&type=script&lang=js"

import exportComponent from "/Users/apple/Desktop/projects/Active Projects/EIEV/Media Dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__